export interface GalleryPhoto {
  src: string;
  className: string;
  rotation?: number;
  type?: string;
}

export const galleryPhotos: GalleryPhoto[] = [
    { src: 'Carrusel-01.png', className: '', rotation:0 },
    { src: 'Carrusel-02.mp4', className: '', rotation: 0, type: "video"},
    { src: 'Carrusel-03.mp4', className: '', rotation:0, type: "video" },
    { src: 'Carrusel-04.png', className: '', rotation: 0 },
    { src: 'Carrusel-05.png', className: '', rotation:0 },
    { src: 'Carrusel-06.png', className: '', rotation: 0 }
];
